export default __webpack_public_path__ + "static/media/Padron_1964AnnSeries_Hm.fe60d8e8.png";